// extracted by mini-css-extract-plugin
export default {"content":"gTUqndpeEAJ4XHbclVlQ","text":"VUFYsw8LQGnv1zdL5HFv","register":"Py7Al2J57DND8aJYz8Ar"};